export default function setupLocalStorageAPI(serviceName: string) {
  return {
    init: (initialData: any, fallbackData: any) => {
      try {
        if (Boolean(localStorage.getItem(serviceName))) {
          localStorage.removeItem(serviceName);
        }
        localStorage.setItem(
          serviceName,
          JSON.stringify(initialData || fallbackData)
        );
        return true;
      } catch {
        return false;
      }
    },
    getData: (fallbackData: any, validationFn?: (data: any) => boolean) => {
      let data = undefined;
      try {
        data = JSON.parse(
          localStorage.getItem(serviceName) || JSON.stringify(fallbackData)
        );
        if (validationFn && !validationFn(data)) {
          return fallbackData;
        }
      } catch (error) {}
      return data;
    },
    updateData: (data: any) => {
      try {
        localStorage.setItem(serviceName, JSON.stringify(data));
      } catch {
        // localStorage unavailable (private browsing, quota exceeded, service worker context)
      }
    },
    clear: () => {
      try {
        localStorage.removeItem(serviceName);
      } catch {}
    }
  };
}
